const CN_AUTOMATION_SESSION_KEY = 'cn_automation_authenticated'

export const CN_AUTOMATION_USERNAME = 'Transpot_CN'
export const CN_AUTOMATION_PASSWORD = 'transpots@cn123'

export function isCnAutomationAuthenticated(): boolean {
  try {
    return sessionStorage.getItem(CN_AUTOMATION_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function setCnAutomationAuthenticated(): void {
  sessionStorage.setItem(CN_AUTOMATION_SESSION_KEY, '1')
}

export function clearCnAutomationAuthenticated(): void {
  sessionStorage.removeItem(CN_AUTOMATION_SESSION_KEY)
}

export function validateCnAutomationLogin(username: string, password: string): boolean {
  return username === CN_AUTOMATION_USERNAME && password === CN_AUTOMATION_PASSWORD
}
